import React, { useEffect, useRef, useState } from "react";
import BussinesCard from "../components/BussinesCard";
import { useTranslation } from "react-i18next";
import Loading from "../components/Loading";
import { Button, Input, message, QRCode, Space } from "antd";
import { FaArrowAltCircleDown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { downloadAntdQR } from "../api/config";
import { getUserCard } from "../store/actions/pcardAction";

const NewBussinesCard = () => {
  const { t } = useTranslation();
  const cardUrlRef = useRef(null);
  const { isLoading } = useSelector((state) => state.bussinesCard);
  const [userCard, setUserCard] = useState({});
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const UUID = searchParams.get("user");
  const branch = searchParams.get("branch");
  useEffect(() => {
    const payload = {
      UUID,
      branch,
    };
    dispatch(getUserCard(payload))
      .unwrap()
      .then((res) => setUserCard(res))
      .catch((err) => message.error(String(err), 4));
  }, [UUID, branch, dispatch]);

  if (isLoading) {
    return <Loading />;
  }
  const handelCopyCardUrl = () => {
    const inputElement = cardUrlRef.current.input;
    if (inputElement) {
      const valueToCopy = inputElement.value;
      navigator.clipboard
        .writeText(valueToCopy)
        .then(() => {
          message.success(t("Copied to clipboard!"));
        })
        .catch(() => {
          inputElement.select();
          document.execCommand("copy");
          message.success(t("Copied to clipboard!"));
        });
    }
  };
  return (
    <div className="new_card">
      <div className="row mt-5">
        <div className="col-sm-12 col-md-8 mb-5">
          <BussinesCard translate={t} userCard={userCard} />
          <div className="mt-5 d-flex flex-wrap">
            <Input
              ref={cardUrlRef}
              value={`${process.env.REACT_APP_DOMAIN}/card/bussines?user=${UUID}&branch=${branch}`}
              disabled
            />
            <Button type="primary" className="px-5 fw-bold fs-5" style={{height:50}} onClick={handelCopyCardUrl}>
              {t("BUTTONS.COPYNFCURL")}
            </Button>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <Space size="large">
            <QRCode
              id={`qr-${UUID}`}
              value={`${process.env.REACT_APP_DOMAIN}/card/bussines?user=${UUID}&branch=${branch}`}
              size={300}
            />
            <div
              onClick={() => {
                downloadAntdQR(UUID, userCard.serial);
              }}
            >
              <FaArrowAltCircleDown color="#44bd32" style={{fontSize:50}} />
            </div>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default NewBussinesCard;
